import { VisibilitySpectrum, Accessibility } from '@/core/Common'
import { APIResource, type Creatable, type Updatable } from '@/core/resources/APIResource'

/**
 * Représente une collection de spectres
 */

export class Collection extends APIResource implements Creatable<Collection>, Updatable<Collection> {
  apiRoute: string = 'collections'

  name: string = ''
  description: string = ''
  visibility: VisibilitySpectrum = VisibilitySpectrum.DISPLAY
  accessibility: Accessibility = Accessibility.PUBLIC
  createDate: Date = new Date()
  updateDate: Date = new Date()
  role: string = ''
  getLines: Array<string> = []
  companionModelAtmosphere: string = ''

  getIdentifier(): any {
    return this.name
  }

  fromJson(json: CollectionResponse): this {
    this.name = json.name
    this.description = json.description
    this.visibility = {
      '0': VisibilitySpectrum.DISPLAY,
      '1': VisibilitySpectrum.READY,
      '2': VisibilitySpectrum.HIDDEN
    }[json.hidden]!
    this.accessibility = {
      '0': Accessibility.PRIVATE,
      '1': Accessibility.PUBLIC
    }[json.accessibility]!
    this.createDate = new Date(json.create_time)
    this.updateDate = new Date(json.update_time)
    this.role = json.role
    this.companionModelAtmosphere = json.comp_mod_atmo
    this.getLines = json.getlines
    return this
  }

  toJsonRequest(): CollectionJsonRequest {
    return {
      name: this.name,
      description: this.description,
      role: this.role,
      comp_mod_atmo: this.companionModelAtmosphere,
      getlines: this.getLines
    }
  }
}

export interface CollectionJsonRequest {
  name: string
  description: string
  role: string
  comp_mod_atmo: string
  getlines: Array<string>
}

export interface CollectionResponse {
  name: string
  hidden: string
  accessibility: string
  description: string
  create_time: string
  update_time: string
  role: string
  comp_mod_atmo: string
  getlines: Array<string>
}

export default Collection
